import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import { toBool } from "lib";
import DateTime from "core/helpers/date/DateTime";
import { DATE_FORMAT, DATETIME_FORMAT, MODULE_DM } from "commons/constants/env";

// ==============================================================
type Props = { row: any; }
// ==============================================================

export default function RowDetails({ row }: Props) {
  const { t } = useTranslation();
  const dmSupport: boolean = toBool(MODULE_DM);

  if (!row) return null;

  return (
    <Box sx={{ margin: 1 }}>
      <Typography variant="h6" gutterBottom component="div">
        {t('history')}
      </Typography>
      <Grid container spacing={2}>
        <Grid xs={10}>
          <Table size="small" aria-label="drugs">
            <TableHead>
              <TableRow>
                <TableCell>{t('date')}</TableCell>
                {dmSupport &&
                  <TableCell>{t('visit')}</TableCell>
                }
                <TableCell>{t('series-and-number')}</TableCell>
                {dmSupport &&
                  <TableCell>{t('expiration-date')}</TableCell>
                }
                <TableCell>{t('released')}</TableCell>
                <TableCell align="right">{t('released-by')}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {row?.drugs?.length > 0 ? row?.drugs?.map((drug: any, index: any) => (
                  <TableRow key={index}>
                    <TableCell component="th" scope="row">
                      {DateTime.toIso(drug?.releasedAt || drug?.createdAt, DATETIME_FORMAT)}
                    </TableCell>
                    {dmSupport &&
                      <TableCell>{drug?.visit?.name}</TableCell>
                    }
                    <TableCell>{drug?.number}</TableCell>
                    {dmSupport &&
                      <TableCell>{DateTime.toIso(drug?.expiredAt, DATE_FORMAT)}</TableCell>
                    }
                    <TableCell>{drug?.drugName}</TableCell>
                    <TableCell align="right">{drug?.owner?.firstname} {drug?.owner?.lastname}</TableCell>
                    <TableCell align="right"></TableCell>
                  </TableRow>
                )) :
                <TableRow>
                  <TableCell colSpan={6} align="center">
                    {t('Empty data')}
                  </TableCell>
                </TableRow>
              }
            </TableBody>
          </Table>
        </Grid>
        <Grid xs={2}></Grid>
      </Grid>
    </Box>
  );
}
